import fastJsonPatch from 'fast-json-patch'; //The idea here is to bring in features as needed

class JsonPatchUtilities {
    static generatePatch(docBefore, docAfter) {
        return fastJsonPatch.compare(docBefore, docAfter);
    }
    static applyPatch(docBefore, patch, mutate = false) {
        const results = fastJsonPatch.applyPatch(docBefore, patch, true, mutate);
        return results.newDocument;
    }
}
export { JsonPatchUtilities };
export default JsonPatchUtilities;